"use strict";

exports.__esModule = true;
exports.MeasureTimelineColumnFieldSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Core = require("../../../Core");
var _Theme = require("../../../Theme");
var _Fields = require("../../AdvancedDataTable/Fields");
var _AdvancedDataTableColumn = require("../../AdvancedDataTableColumn");
var _MultiAggregateSelector = require("../../common/MultiAggregateSelector");
var _AggregateTimeDefinitions = require("../AggregateTimeDefinitions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var NoOptionLabel = _styledComponents["default"].div.withConfig({
  displayName: "MeasureTimelineColumnFieldSelector__NoOptionLabel",
  componentId: "sc-1xzmrcs-0"
})(["margin-bottom:15px;font-weight:", ";"], (0, _Theme.val)("fontWeightHeavy"));
var MeasureTimelineColumnFieldSelector = exports.MeasureTimelineColumnFieldSelector = function MeasureTimelineColumnFieldSelector(props) {
  var path = props.path,
    elementEditor = props.elementEditor,
    element = props.element,
    measureColumns = props.measureColumns,
    dimensionColumns = props.dimensionColumns,
    data = props.data;
  var timelineIdentifiers = data.timelineIdentifiers;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var selectedDimensions = element.children.map(function (child) {
    return child.props;
  }).filter(function (child) {
    return child.dataType === "dimensions";
  });
  var selectedMeasures = element.children.map(function (child) {
    return child.props;
  }).filter(function (child) {
    return child.dataType === "measures";
  });
  var onItemClick = function onItemClick(column, dataType) {
    var existingColumn = element.children.find(function (def) {
      return def.props.id === column.id;
    });
    if (existingColumn) {
      var filteredColumns = element.children.filter(function (col) {
        return col !== existingColumn;
      });
      elementEditor.replaceElementAt(path, Object.assign({}, element, {
        children: filteredColumns
      }));
    } else {
      elementEditor.appendElementAt(path, _AdvancedDataTableColumn.AdvancedDataTableColumnWidget.createElement(Object.assign({
        dataType: dataType
      }, column)));
    }
  };
  var dataSource = element.props.dataSource;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Fields.AdvancedDataSourceField, {
    sources: timelineIdentifiers || [],
    value: dataSource,
    label: translate("AdvancedTimelineFields.TimelineSelector.label", "Timeline"),
    setProp: function setProp(val) {
      if (val !== dataSource) {
        var children = element.children.filter(function (def) {
          return _AggregateTimeDefinitions.timeArray.includes(def.props.id);
        });
        elementEditor.modifyElementAt(path, function (el) {
          if (el.props.dataSource !== val) {
            el.props.configuration = null; // this triggers bootstrap above
            el.children = children;
            el.props.dataSource = val;
          }
        });
      }
    }
  }), dimensionColumns.length === 0 ? /*#__PURE__*/_react["default"].createElement(NoOptionLabel, null, "No Dimension") : /*#__PURE__*/_react["default"].createElement(_MultiAggregateSelector.MultiAggregateSelector, {
    label: translate("AggregateMeasureTable.selectDimensions", "Select Dimensions"),
    placeholderLabel: translate("AggregateMeasureTable.addDimension", "Add Dimension"),
    style: {
      marginBottom: 0
    },
    items: dimensionColumns,
    tags: dimensionColumns.map(function (_ref) {
      var groupId = _ref.groupId;
      return groupId;
    }),
    selected: selectedDimensions,
    getClickedItem: function getClickedItem(column) {
      return onItemClick(column, "dimensions");
    },
    onSelect: function onSelect() {}
  }), measureColumns.length === 0 ? /*#__PURE__*/_react["default"].createElement(NoOptionLabel, null, "No Measure") : /*#__PURE__*/_react["default"].createElement(_MultiAggregateSelector.MultiAggregateSelector, {
    label: translate("AggregateMeasureTable.selectMeasures", "Select Measures"),
    placeholderLabel: translate("AggregateMeasureTable.addMeasure", "Add Measure"),
    style: {
      marginBottom: 0
    },
    items: measureColumns,
    tags: measureColumns.map(function (_ref2) {
      var groupId = _ref2.groupId;
      return groupId;
    }),
    selected: selectedMeasures,
    getClickedItem: function getClickedItem(column) {
      return onItemClick(column, "measures");
    },
    onSelect: function onSelect() {}
  }));
};